import React, { useState, useEffect, useCallback } from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Label } from '../../components/ui/label';
import { Megaphone, Zap, Loader2, CheckCircle, XCircle } from 'lucide-react';
import api from '../../services/api';
import { toast } from '../../hooks/use-toast';
import AdminLayout from '../../components/admin/AdminLayout';

const AdminMarketingContent = () => {
  const [popupActive, setPopupActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem('admin_token');
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(async () => {
    try {
      const res = await api.get('/marketing/popup-config');
      setPopupActive(res.data.is_express_popup_active || false);
    } catch { /* silent */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = async (val) => {
    setSaving(true);
    try {
      await api.put('/marketing/popup-config', { is_express_popup_active: val }, { headers });
      setPopupActive(val);
      toast({ title: val ? 'Pop-up activado' : 'Pop-up desactivado' });
    } catch {
      toast({ title: 'Error', variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-orange-500" /></div>;
  }

  return (
    <div className="space-y-6" data-testid="admin-marketing-page">
      <div>
        <h1 className="text-2xl font-bold text-white flex items-center gap-2"><Megaphone className="w-6 h-6 text-orange-400" /> Marketing</h1>
        <p className="text-gray-400 text-sm mt-1">Herramientas de captacion y conversion</p>
      </div>

      <Card className="bg-gray-800 border-gray-700 p-8">
        <div className="flex items-center gap-6">
          <div className={`w-20 h-20 rounded-2xl flex items-center justify-center ${popupActive ? 'bg-orange-500/20' : 'bg-gray-700'}`}>
            <Zap className={`w-10 h-10 ${popupActive ? 'text-orange-400' : 'text-gray-500'}`} />
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-bold text-white">Pop-up de Registro Expres</h2>
            <p className="text-gray-400 text-sm mt-1">
              Se muestra a visitantes no registrados despues de 5 segundos en la pagina principal. Solo aparece una vez por sesion.
            </p>
            <div className="flex items-center gap-3 mt-3">
              {popupActive ? (
                <span className="text-green-400 text-sm flex items-center gap-1"><CheckCircle className="w-4 h-4" /> Activo</span>
              ) : (
                <span className="text-gray-500 text-sm flex items-center gap-1"><XCircle className="w-4 h-4" /> Desactivado</span>
              )}
            </div>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Switch
              checked={popupActive}
              onCheckedChange={toggle}
              disabled={saving}
              data-testid="popup-toggle"
              className="scale-150"
            />
            <Label className="text-xs text-gray-500">{saving ? 'Guardando...' : ''}</Label>
          </div>
        </div>
      </Card>
    </div>
  );
};

export const AdminMarketing = () => (
  <AdminLayout>
    <AdminMarketingContent />
  </AdminLayout>
);
